export default __webpack_public_path__ + "static/media/fundoFlor1.8a6e4001.png";